import { Grid, Typography, Divider, Box } from "@mui/material";
import { InputField } from "../../../../utils/FormFields";
import DatePicker from "../../../../utils/FormFields/DatePicker";
import SwitchField from "../../../../utils/FormFields/ActiveField";
import { FileBodyTypeEnum } from "../../../../api/file-management";
import UploadField from "../../../../utils/FormFields/UploadField";
import CountryField from "../../../../utils/FormFields/CountryField";

export default function EmployeeInsurance() {
  return (
    <>
      <Typography variant="h5" gutterBottom sx={{ p: 0 }}>
        Employee Insurance
      </Typography>
      <Divider />
      <Grid container rowSpacing={4} spacing={2} sx={{ pt: 8, justifyContent: "center", alignContent: "center" }}>
        <Grid xs={12} sm={6}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.Insurance.InsuranceNb" label="Insurance Nb" fullWidth />
          </Box>  
        </Grid>
        <Grid container />

        <Grid xs={12} sm={3}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.Insurance.InsuranceCompany" label="Insurance Company" fullWidth />
          </Box>  
        </Grid>
        <Grid xs={12} sm={3}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <CountryField name="User.Insurance.InsuranceCountry" label="Insurance Country"/>
          </Box>  
        </Grid>
        <Grid container />

        <Grid xs={12} sm={6}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <InputField name="User.Insurance.InsurancePolicy" label="Insurance Policy" fullWidth />
          </Box>  
        </Grid>
        <Grid container />

        <Grid xs={12} sm={3}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <DatePicker name="User.Insurance.IssuedDate" label="Issued Date" />
          </Box>  
        </Grid>
        <Grid xs={12} sm={3}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <DatePicker name="User.Insurance.ExpiryDate" label="Expiry Date" />
          </Box>  
        </Grid>
        <Grid container />

        <Grid xs={12} sm={2.5}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <UploadField
              name="User.Insurance.InsuranceIDImageURI"
              label="Insurance ID Image"
              fileType={FileBodyTypeEnum.INSURANCEID}
              fullWidth
            />
          </Box>  
        </Grid>
        <Grid xs={12} sm={2}>
          <Box sx={{ pl: 1, pt: 2 }}>
            <SwitchField name="User.Insurance.Active" label="Insurance Active ?" />
          </Box>            
        </Grid>
      </Grid>
    </>
  );
}
